import React, { useEffect } from 'react';
import '../App.css';
import './BGwordanimation4.css';

function BGwordanimation4({ children, wordClassName }) {
  useEffect(() => {
    // This effect can be used to handle other side effects if needed
  }, []);

  return (
    <div className={`word_container4 ${wordClassName}`}>
      <div className="scrolling-banner4">
        <p id='wordanimation'>Yokai Software and Web Development</p><p id='wordanimation_second'>Captivating Designs That Engage and Convert</p> <p id='wordanimation2'> - Yokai Software and Web Development,</p><p id='wordanimation_second2'>Captivating Designs That Engage and Convert</p>
        
      </div>
      <div className="content">{children}</div>
    </div>
  );
}

export default BGwordanimation4;
